import React, { Component, useState , useEffect} from 'react';
import './MainBottomVerticalGaugeGraph.css';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { useSelector } from 'react-redux';
import { formatPower, formatCO2Reduction } from '../../public/formatPower'; // 유틸리티 함수 불러오기
import useIsMobile from '../../hooks/useIsMobile';

function MainBottomVerticalGaugeGraph({ prevMonthPower = null }) {

  const isMobile = useIsMobile();
  // 리덕스에서 iv_capa 배열 가져오기
  const ivCapa = useSelector((state) => state.Iv_list.iv_capa);
  const ivData = useSelector((state) => state.ivData);
  // const AddPower = useSelector((state) => state.ivData.Add_power);
  // const AddPower = useSelector((state) => state.ivData.Add_power);

  // 모듈 용량 값을 상태로 관리
  const [totalCapa, setTotalCapa] = useState(0);
  const [totalAdd_power, setTotalAdd_power] = useState(0);
  const [totaltodayAdd, setTotaltodayAdd] = useState(0);
  const [totalthisMonthAdd, setTotalthisMonthAdd] = useState(0);
  const [totalthisYearAdd, setTotalthisYearAdd] = useState(0);




  useEffect(() => {
    if (ivCapa && ivCapa.length > 0) {
      const sumCapa = ivCapa.reduce((acc, val) => acc + val, 0);
      setTotalCapa(sumCapa);  // totalCapa 상태 업데이트
    }
  }, [ivCapa]);  // iv_capa 값이 변경될 때마다 실행


  useEffect(() => {
    if (ivData.Add_power && ivData.Add_power.length > 0) {
      const sumAdd_power = ivData.Add_power.reduce((acc, val) => acc + val, 0);
      setTotalAdd_power(sumAdd_power);  
    }
    // console.log("totalAddPower:", totalAddPower);
  }, [ivData.Add_power]);  // AddPower 값이 변경될 때마다 실행


  useEffect(() => {
    if (ivData.todayAdd && ivData.todayAdd.length > 0) {
      const sumtodayAdd = ivData.todayAdd.reduce((acc, val) => acc + val, 0);
      setTotaltodayAdd(sumtodayAdd);  
    }
  }, [ivData.todayAdd]); 

  useEffect(() => {
    if (ivData.thisMonthAdd && ivData.thisMonthAdd.length > 0) {
      const sumthisMonthAdd = ivData.thisMonthAdd.reduce((acc, val) => acc + val, 0);
      setTotalthisMonthAdd(sumthisMonthAdd);  
    }
  }, [ivData.thisMonthAdd]); 

  useEffect(() => {
    if (ivData.thisYearAdd && ivData.thisYearAdd.length > 0) {
      const sumthisYearAdd = ivData.thisYearAdd.reduce((acc, val) => acc + val, 0);
      setTotalthisYearAdd(sumthisYearAdd);  
    }
  }, [ivData.thisYearAdd]); 


  return (
    <div style={{marginBottom:'30px'}}>

      <div className='main-Vchart-TopBox'>
        <div className="main-Vchart-title" style={{ color: '#6B7476', fontSize: '20px', fontWeight: '600', paddingLeft: '20px' }}>◎ 발전현황 </div>
        <div className="main-Vchart-flex-space" style={{ flexGrow: '1' }}></div>
        <div className="main-Vchart-options" style={{ color: '#6B7476', fontSize: '20px', fontWeight: '600', paddingRight: '20px' }}>⦁ ⦁ ⦁</div>
      </div>
      <div className='main-Vchart-BottomBox' style ={{ flexDirection: isMobile ? 'column' : 'row'}}>
        
        <div className='main-Vchart-BottomBox-right' style={{ borderRight: '1px solid var(--divider, #e5e9f0)' }}><ComponentMainVchart title={'평균 발전시간'} count={0} addpower={totaltodayAdd} totalCapa = {totalCapa} prevMonthPower={prevMonthPower} /></div> 
        <div className='main-Vchart-BottomBox-right' style={{ borderRight: '1px solid var(--divider, #e5e9f0)' }}><ComponentMainVchart title={'누적 발전시간'} count={1} addpower={totalthisMonthAdd} totalCapa = {totalCapa}/></div>
        <div className='main-Vchart-BottomBox-right' style={{ borderRight: '1px solid var(--divider, #e5e9f0)' }}><ComponentMainVchart title={'누적 발전시간'} count={2} addpower={totalthisYearAdd} totalCapa = {totalCapa}/></div>
        <div className='main-Vchart-BottomBox-right' style={{ borderRight: '0px solid var(--divider, #e5e9f0)' }}><ComponentMainVchart title={'총 발전시간'}   count={3} addpower={totalAdd_power} totalCapa = {totalCapa}/></div>

      </div>

    </div>

  );

};




// 1. 누적 24637시간 (4.5시간씩 15년 기준 )비율로 그래프 표시 
// 2. 금년 1642시간 (4.5시간씩 1년기준) 비율로 그래프 표시 
// 3. 금월 139시간 (4.5시간씩 31일기준) 비율로 그래프 표시 
// 4. 금일 4.5시간씩 1일기준 비율로 그래프 표시 


function ComponentMainVchart({ title, count, addpower, totalCapa, prevMonthPower = null }) {



  const [gaugeData, setGaugeData] = useState({
    gaugeRatio: [30, 70],
    BottomTitle: '발전전력',
    gaugeValue: 50, // 예시 값
    gaugeMaxValue: 100 // 예시 값
  });

  // 발전 비율 계산 함수
  const calculateGaugeValue = (addpower, maxTime) => {
    const ratio = (addpower / maxTime) * 100;
    return ratio > 100 ? 100 : ratio; // 비율이 100을 넘지 않도록 제한
  };

  useEffect(() => {
    // 각 기준에 따른 발전 시간 (기본적으로 하루 4.5시간으로 계산)
    const maxTimePerDay = 3.5; // 하루 최대 발전 시간
    const maxTimePerMonth = 3.5 * 31; // 금월 (31일 기준)
    const maxTimePerYear = 3.5 * 365; // 금년 (1년 기준)
    const maxTimeCumulative = maxTimePerYear * 15; // 누적 (15년 기준)

    let gaugeValue = 0;

  // count 값에 따라 발전 시간을 기준으로 비율 계산
  if (count === 0) {
    // 금일 기준
    gaugeValue = calculateGaugeValue(((addpower/1000) / totalCapa), maxTimePerDay);
    // console.log("금일 기준 gaugeValue:", gaugeValue);
  } else if (count === 1) {
    // 금월 기준
    gaugeValue = calculateGaugeValue(((addpower/1000) / totalCapa), maxTimePerMonth);
    // console.log("금월 기준 gaugeValue:", gaugeValue);
  } else if (count === 2) {
    // 금년 기준
    gaugeValue = calculateGaugeValue(((addpower/1000) / totalCapa), maxTimePerYear);
    // console.log("금년 기준 gaugeValue:", gaugeValue);
  } else if (count === 3) {
    // 누적 기준 (15년)
    gaugeValue = calculateGaugeValue(((addpower/1000) / totalCapa), maxTimeCumulative);
    // console.log("누적 기준 gaugeValue:", gaugeValue);
  }

  setGaugeData({
    gaugeRatio: [50, 50],
    BottomTitle: '발전전력',
    gaugeValue: gaugeValue,
    gaugeMaxValue: 100 
  });
  
}, [addpower, count, totalCapa]);  // 의존성 배열에 totalCapa 없음



  // 발전량과 CO₂ 절감량 포맷팅 결과
  const powerData = formatPower(addpower, "Add");
  const co2Data = formatCO2Reduction(addpower);

  return (
    <div>
      <Container className="MainBottomBoxCon">
        <Row style={{ height: '40px' }}>
          <div className="gen-image-container">
            {count === 0 ? (
              <>
                <div className="gen-image-crop" style={{ top: '0px', left: '0px', marginLeft: '15px' }}></div>
                <span style={{ marginLeft: '30px' }}>
                  금일{' '}
                  <span style={{ fontSize: '0.85em', fontWeight: 500 }}>
                    {prevMonthPower && Number.isFinite(Number(prevMonthPower.value))
                      ? `(전일 발전량: ${Number(prevMonthPower.value).toFixed(2)}${prevMonthPower.unit || ''})`
                      : '(전일 발전량: 정보없음)'}
                  </span>
                </span>
              </>
            ) : null}
            {count === 1 ? (
              <>
                <div className="gen-image-crop" style={{ top: '-20px', left: '0px', marginLeft: '15px' }}></div>
                <span style={{ marginLeft: '30px' }}>금월</span>
              </>
            ) : null}
            {count === 2 ? (
              <>
                <div className="gen-image-crop" style={{ top: '-40px', left: '0px', marginLeft: '15px' }}></div>
                <span style={{ marginLeft: '30px' }}>금년</span>
              </>
            ) : null}
            {count === 3 ? (
              <>
                <div className="gen-image-crop" style={{ top: '-60px', left: '0px', marginLeft: '15px' }}></div>
                <span style={{ marginLeft: '30px' }}>총 누적 [인버터]</span>
              </>
            ) : null}
          </div>
        </Row>

        <Row style={{ height: '100%' }}>
          <Col><VerticalGaugeGraph data={gaugeData} /></Col>

          <Col className='text-genlist-ColStyle_custom'>
            <Row className='text-genlist-custom'>{title}</Row>
            <Row className='text-genlist-custom'>발전량</Row>
            <Row className='text-genlist-custom'>CO₂ 절감량</Row>
          </Col>

          <Col className='text-genlist-ColStyle_custom'>
            <Row className='text-gendata-custom' style={{ color: '#F48A00', fontSize: 'x-large' }}>
              {(addpower / (totalCapa * 1000)).toFixed(1)}
            </Row>
            <Row className='text-gendata-custom' style={{ color: '#F64747', fontSize: 'x-large' }}>
              {powerData.value}
            </Row>
            <Row className='text-gendata-custom' style={{ color: '#30C284', fontSize: 'x-large' }}>
              {co2Data.value}
            </Row>
          </Col>

          <Col className='text-genlist-ColStyle_custom'>
            <Row className='text-genType-custom' style={{ color: '#F48A00' }}>h</Row>
            <Row className='text-genType-custom' style={{ color: '#F64747' }}>{powerData.unit}</Row>
            <Row className='text-genType-custom' style={{ color: '#30C284' }}>{co2Data.unit}</Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
}



















class VerticalGaugeGraph extends Component {
  canvasRef = React.createRef();

  state = {
    gauge: [],
    gaugeColors: [
      ['#ff8300', '#fe8000'],
      ['#fd7b00', '#fd7700'],
      ['#fc7200', '#fa6c00'],
      ['#fa6600', '#f86000'],
      ['#f65900', '#f65300'],
      ['#f44d00', '#f34600'],
      ['#f24000', '#f13a00'],
      ['#f03400', '#ee3000'],
      ['#ee2c00', '#ee2800'],
      ['#ed2700', '#ed2700']
    ],
  }

  componentDidMount() {
    this.verticalGaugeDrawer();
    this.drawCircle();
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(this.props.data) !== JSON.stringify(prevProps.data)) {
      this.verticalGaugeDrawer();
    }
    this.drawCircle();
  }

  drawCircle = () => {
    const canvas = this.canvasRef.current;
    const ctx = canvas.getContext('2d');

    // 고정된 너비와 높이
    const width = 80; 
    const height = 110;

    // Clear the canvas
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Draw the white circle
    ctx.beginPath();
    const radius = height / 0.8;
    ctx.arc(width * 2, height / 1, radius, 0, 2 * Math.PI);
    ctx.fillStyle = 'white';
    ctx.fill();
  };

  verticalGaugeDrawer = () => {
    const { data = {} } = this.props;
    const { gaugeValue = 0, gaugeMaxValue = 1 } = data; // 기본값 설정
    const percent = Math.round((isNaN(gaugeValue / gaugeMaxValue) ? 0 : gaugeValue / gaugeMaxValue) * 10) * 10;

    // 고정된 너비와 높이
    const parentWidth = 80; 
    const barHeight = 110 / 10; // 모든 바의 높이 동일하게 설정

    const gauge = [];
    for (let i = 0; i < 10; i++) {
      const level = (i + 1) * 10;
      let jsx = null;

      if (percent >= level) {
        const style = {
          backgroundImage: `linear-gradient(to right, ${this.state.gaugeColors[i][0]} 0%, ${this.state.gaugeColors[i][1]} 100%)`,
          width: `${parentWidth}px`, // 바의 너비 설정
          height: `${barHeight}px`,
          borderTopLeftRadius: '3px',
          borderBottomLeftRadius: '3px',
        };
        jsx = <div className="gauge" key={i} style={style} />;
      } else {
        const style = {
          backgroundColor: 'grey',
          width: `${parentWidth}px`, // 바의 너비 설정
          height: `${barHeight}px`,
          borderTopLeftRadius: '3px',
          borderBottomLeftRadius: '3px',
        };
        jsx = <div className="gauge" key={i} style={style} />;
      }

      gauge.push(jsx);
    }

    this.setState({ gauge });
  }

  render() {
    // 고정된 스타일 설정
    const style = {
      width: '80px',
      height: '110px',
      margin: '0px'
    };

    return (
      <div className="vertical-gauge-wrap" style={style}>
        {this.state.gauge}
        <canvas ref={this.canvasRef} className="overlay" width="80" height="110"></canvas>
      </div>
    );
  }
}

export default MainBottomVerticalGaugeGraph;
